import React, { Component } from "react";
import { connect } from "react-redux";
import { ubicationsService } from "services";
import { FiPlus, FiMoreHorizontal, FiSearch, FiDownload } from "react-icons/fi";
import { FormGroup, FormControl, FormLabel, Dropdown } from "react-bootstrap";
import Layout from "components/Layout";
import Loading from "components/Loading";
import Switch from "components/Switch";
import UbicationEdit from "components/Ubications/UbicationEditModal";
import Modal from "components/Modal";
import { showModal, hideModal } from "actions/modalActions";
import * as ubicationsActions from "actions/ubicationsActions";
import { errorFormating } from "utils/utils";
import { withTranslation } from "react-i18next";
import DataTable from "components/DataTable";
import HelpBanner from "components/HelpBanner";
import { helpUrls } from "utils/helpUrls";

class Ubications extends Component {
	constructor(props) {
		super(props);
		//console.log(props);

		this.closeModal = this.closeModal.bind(this);
		this.openNewUbicationModal = this.openNewUbicationModal.bind(this);
		this.openEditUbicationModal = this.openEditUbicationModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getUbications = this.getUbications.bind(this);

		this.state = {
			active_only: true,
			search_ubication: "",
		};
	}

	componentDidMount() {
		this.getUbications();
	}

	async getUbications() {
		await this.props.getAllUbications({
			q: this.state.search_ubication,
			enabled: this.state.active_only,
		});
		// console.log(this.props);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewUbicationModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.newUbication"),
				style: { width: "450px" },
				content: (
					<UbicationEdit
						getUbications={this.getUbications}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditUbicationModal(ubication) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.editUbication"),
				style: { width: "450px" },
				content: (
					<UbicationEdit
						getUbications={this.getUbications}
						ubication={ubication}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteUbicationModal(idUbication) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.deleteUbication"),
				style: { width: "400px" },
				message:
					this.props.t("ubications.deleteConfirmation"),
				deleteAction: () => this.confirmDelete(idUbication),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.deleteError"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idUbication) => {
		const response = await ubicationsService.remove(idUbication);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.getUbications();
			this.closeModal();
		}
	};

	handleChangeSearch = (event) => {
		const targetId = event.target.id;

		this.setState(
			{
				[targetId]:
					targetId === "active_only"
						? event.target.checked
						: event.target.value,
			},
			() => {
				this.getUbications();
			}
		);
	};

	getUbicationColumns = () => [
		{
			key: "name",
			header: this.props.t("ubications.form.name"),
			render: (ubication) => (
				<button
					type="button"
					className="btn-transparent btn-editable"
					onClick={() => this.openEditUbicationModal(ubication)}
				>
					{ubication.name}
				</button>
			),
		},
		{
			key: "description",
			header: this.props.t("ubications.form.description"),
			render: (ubication) => ubication.description,
		},
		{
			key: "status",
			header: this.props.t("common.status"),
			align: "center",
			render: (ubication) =>
				ubication.enabled ? (
					<span title={this.props.t("common.active")} className="estado estado-si">{this.props.t("common.active")}</span>
				) : (
					<span title={this.props.t("common.inactive")} className="estado estado-no">{this.props.t("common.inactive")}</span>
				),
		},
		{
			key: "color",
			sortable: false,
			header: "",
			headerTitle: "Color",
			headerClassName: "td-icon",
			align: "center",
			className: "td-icon",
			render: (ubication) => (
				<span
					className="bolita"
					style={{
						backgroundColor:
							ubication.background_color && ubication.background_color,
						borderColor: ubication.border_color && ubication.border_color,
					}}
				/>
			),
		},
	];

	getContent = () => {
		if (this.props.loading) {
			return <Loading />;
		}

		if (this.props.error) {
<div className="no-results">{this.props.t("ubications.errorLoading")}</div>
		}

		const ubications = this.props.ubications || [];

		return (
			<DataTable
				tableClassName="table-ubications table-hover"
				tableStyle={{ backgroundColor: "#ffffff" }}
				columns={this.getUbicationColumns()}
				rows={ubications}
				rowKey={(row) => row.id}
				emptyMessage={this.props.t("ubications.noUbications")}
				actionsColumn={{
					render: (ubication) => (
						<Dropdown>
							<Dropdown.Toggle variant="action">
								<FiMoreHorizontal />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item
									as="button"
									onClick={() => this.openEditUbicationModal(ubication)}
								>
									{this.props.t("common.edit")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() => this.openDeleteUbicationModal(ubication.id)}
								>
									{this.props.t("common.delete")}
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					),
					className: "td-actions",
				}}
			/>
		);
	};

	render() {
		const { active_only } = this.state;

		return (
			<>
				<Layout
					configSidebar={true}
					className="page-ubications"
					context="employees"
				>
					<div className="heading">
						<h1 className="title">{this.props.t("ubications.title")}</h1>
						<div className="heading-help-banner heading-config hidden-sm">
							<HelpBanner
								title={this.props.t("common.needHelp")}
								// text="Encuentra todo en un solo lugar."
								linkText={this.props.t("common.moreInfo")}
								linkHref={helpUrls.ubication}
							/>
						</div>

						<div className="heading-filters">
							<FormGroup
								className="form-group form-group-flex form-switch"
								controlId="active_only"
							>
								<Switch
									controlId="active_only"
									isOn={active_only}
									handleToggle={this.handleChangeSearch}
								/>
								<FormLabel>{this.props.t("ubications.showActive")}</FormLabel>
							</FormGroup>

							<FormGroup
								className="form-group form-search"
								controlId="search_ubication"
							>
								<FormControl
									type="text"
									placeholder={this.props.t("common.searchPlaceholder")}
									value={this.state.search_ubication}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>

						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t("ubications.createUbication")}
								onClick={this.openNewUbicationModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.history.push("/ubications/import")
										}
									>
										<FiDownload className="dropdown-icon" /> {this.props.t('ubications.importUbications')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.ubicationsReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllUbications: (options) =>
		dispatch(ubicationsActions.getAllUbications(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Ubications));
// export default connect(null, mapDispatchToProps)(Ubications)
